import Hero from "../../components/Hero";
import TaxImage from "../../../assets/images/Tax1.jpg";
import TaxImage1 from "../../../assets/images/Tax 2.jpg";
import TaxImage3 from "../../../assets/images/tax 3.jpg";
import "../../../css/pages/landingPage.css"
const Taxation = () => {
  return (
    <div>
      <Hero
        backgroundImage={TaxImage}
        title="Taxation"
        subtitle="OUR SERVICES"
      />
      <div className="landing-page ">
        <div className="light-row">
          <div className="column">
            <div className="title-semibold primary">Capital Gains Tax</div>
            <div className="content primary">
              CGT is a tax on capital 'gains'. If when you sell or give away an
              asset it has increased in value, you may be taxed on the 'gain'
              (profit). This doesn't apply when you sell personal belongings
              worth £3,000 or less or, in most cases, your main home.
            </div>
            <div className="content primary">
              In the tax year 2025/2026, an individual’s CGT allowance is £3000.
            </div>
            <div className="content primary">
              This means you do not have to pay tax on gains from buying and
              selling shares or other investments during the tax year up to that
              amount. You do not normally have to pay tax on any gain you make
              when you sell your main residence.
            </div>
          </div>
          <img
            src={TaxImage1}
            alt="Capital Gains Tax"
            className="service-image"
          />
        </div>
      </div>
        <div className="primary-container">
          <div className="column align-center">
            <div className="title-semibold">Income Tax Allowances</div>
            <div className="content-semibold">
              PLEASE NOTE: The figures shown below apply to English taxpayers.
              Scottish taxpayers have different rates and bands. For more
              details, visit
              https://www.gov.scot/publications/scottish-income-tax-2025-2026-factsheet/pages/1/.
            </div>
            <div className="content">
              The income tax Personal Allowance for the year 2025/2026 is
              £12,570 (2024/2025 was also £12,570). If your total income is less
              than this during the tax year, you have no tax to pay.
            </div>
          </div>
        </div>
      <div className="landing-page ">

        <div className="light-row">
          <img
            src={TaxImage3}
            alt="Capital Gains Tax"
            className="service-image"
          />
          <div className="column">
            <div className="title-semibold primary">Inheritance Tax</div>
            <div className="content primary">
              The government levies tax on the value of a person’s estate, if
              their estate is worth more than the Nil Rate Band. The IHT ‘Nil
              Rate Band’ (NRB) is currently £325,000 (2025/2026) and many people
              are still getting caught in the trap of property inheritance tax
              as the threshold has not kept pace with the inflation of property
              prices, and so is affecting more and more people.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Taxation;